import { GlassCard } from "./GlassCard";

export const FeatureCard = ({ icon: Icon, title, description, items, testId }) => (
  <GlassCard className="group flex h-full flex-col p-8" data-testid={testId}>
    <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] transition-colors duration-300 group-hover:border-white/25">
      <Icon className="h-5 w-5 text-paper-100" aria-hidden="true" />
    </div>
    <h3 className="mt-6 font-display text-xl font-semibold tracking-tight text-paper-100">{title}</h3>
    {description && <p className="mt-3 text-sm leading-relaxed text-paper-400">{description}</p>}
    {items && (
      <ul className="mt-5 flex flex-wrap gap-2">
        {items.map((item) => (
          <li
            key={item}
            className="rounded-full border border-white/10 px-3 py-1 text-xs text-paper-400"
          >
            {item}
          </li>
        ))}
      </ul>
    )}
  </GlassCard>
);
